
import React, { useState, useEffect } from 'react';
import './FAQ.css';
import Wave from '../Asset/svgviewer-png-output.png';
import { ReactComponent as ArrowIcon } from '../Asset/up-arrow-svgrepo-com.svg';
import arrowBottom from '../Asset/Arrow 6.png';

 
const GroupPersonalAccidentFAQ = () => {

  const [faqs] = useState([
    {
      question: "Q1. What types of accidents are covered by this insurance?",
      answer:
      (
        <>
           "Group Personal Accident insurance typically covers a wide range of accidents, including:<br></br>
           <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>1.Workplace Accidents:</span> Injuries sustained while performing job-related duties.
           <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>2.Commuting Accidents:</span> Accidents that occur while traveling to or from work.
           <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>3.Home Accidents:</span>  Injuries that happen at home or on personal premises.
           <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>4.Traffic Accidents: </span>Injuries resulting from car, motorcycle, bicycle, or pedestrian accidents.
           <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>5.Sports and Recreational Accidents:</span> Injuries from participating in sports or recreational activities, subject to policy terms.
           <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>6.Slips and Falls: </span>Injuries from slipping, tripping, or falling in various environments.
           <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>7.Natural Disasters:</span> Injuries resulting from natural disasters like earthquakes, floods, or storms, depending on policy terms.
           <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>8.Accidental Death:</span> Fatal accidents leading to the death of the insured individual.
           <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>9.Permanent or Temporary Disability: </span>Accidents causing temporary or permanent disabilities."
        </>
      )
    },
    {
      question: "Q2. Does group personal accident insurance covers all types of injuries?",
      answer:
      (
        <>
          Group Personal Accident insurance typically covers a wide range of injuries resulting from accidents. However, the exact coverage can vary based on the specific policy terms and conditions. Commonly covered injuries include those resulting in <span style={{ color: "#F37435", fontWeight: "700" }}>disability, dismemberment, or death caused by accidents.</span>  It's important to review the policy details to understand any specific exclusions or limitations on the types of injuries covered under your Group Personal Accident insurance.
        </>
      ) 
    },
    {
      question: "Q3. If I am covered under Group personal accident? Will my family be covered as well?",
      answer:
      (
        <>
          If you are covered under Group Personal Accident insurance, typically, <span style={{ color: "#F37435", fontWeight: "700" }}>your family members are not automatically covered.</span> Group Personal Accident insurance primarily covers accidents and injuries that happen to the insured individual (the employee). However, some insurance policies may offer the option to extend coverage to family members through additional riders or supplementary plans, often at an extra cost. It's important to review the specific terms of your insurance policy to understand whether family coverage is included or available as an option.
        </>
      ) 
    },
    {
      question: "Q4. What factors influence the premium cost of a Group Personal Accident policy?",
      answer:
      (
        <>
          The premium cost of a Group Personal Accident policy is influenced by factors such as <span style={{ color: "#F37435", fontWeight: "700" }}>coverage limits, group size and demographics, nature of work, claims history, policy features, underwriting criteria, and geographical coverage.</span> These factors help insurers assess risk and determine the pricing of the policy.
        </>
      ) 
    },
    {
      question: "Q5. Is there a waiting period for coverage to begin?",
      answer: 
      (
      <>
        Typically, <span style={{ color: "#F37435", fontWeight: "700" }}>there is no waiting period</span> for Group Personal Accident insurance coverage to begin. Coverage usually starts immediately upon the policy's effective date, ensuring that employees or members are protected from accidents right away. However, it's important to review your specific policy details to confirm this, as terms can vary between insurers.
      </>
      )
    
    },
   
    {
      question: "Q6. What does permanent disability mean in a Group Personal Accident policy?",
      answer:
      (
        <>
          In a Group Personal Accident policy, permanent disability refers to a condition where the insured individual suffers a <span style={{ color: "#F37435", fontWeight: "700" }}>lasting impairment due to an accident.</span> This impairment typically prevents the insured from performing specific tasks or engaging in regular employment. The policy outlines various levels of permanent disability, such as total permanent disability (where the insured is completely unable to work) or partial permanent disability (where the insured can work but with limitations). Compensation under the policy is based on the severity of the disability as defined in the terms and conditions of the insurance contract. It's essential to review the policy details to understand the specific definitions and benefits related to permanent disability coverage.
        </>
      ) 
    },
    {
      question: "Q7. What happens if an insured member leaves the organization?",
      answer:
      (
        <>
          If an insured member leaves the organization, their coverage under the Group Personal Accident insurance policy typically ends. However, here are some options that might be available:<br></br>
          <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>a.Termination of Coverage: </span>Coverage usually ceases as soon as the individual leaves the organization, as they are no longer part of the insured group.
          <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>b.Conversion Option:</span> Some policies may offer a conversion option, allowing the departing member to convert their group coverage to an individual policy. This may require payment of individual premiums and adherence to specific terms set by the insurer.
          <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>c.Portability:</span> In some cases, the insurance policy may offer portability options where the departing member can transfer their coverage to a new group policy with their new employer, subject to the insurer's terms and conditions.
          <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>d.Grace Period:</span> Some policies may provide a short grace period during which coverage continues after the employee leaves, giving them time to arrange for alternative insurance.
        </>
      ) 
    },
    {
      question: "Q8. Can coverage be extended to include non-work-related accidents?",
      answer:
      (
        <>
           Yes, coverage under a Group Personal Accident insurance policy <span style={{ color: "#F37435", fontWeight: "700" }}>can often be extended to include non-work-related accidents.</span>  This means that the policy can provide protection for accidents that occur outside of work, such as at home, during travel, or while participating in recreational activities.
        </>
      ) 
    },
    {
      question: "Q9. What is the process for adding or removing members from the policy?",
      answer:
      (
        <>
          The process for adding or removing members from a Group Personal Accident policy typically involves the following steps:<br></br>
          <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>1.Notify Insurer:</span> Inform the insurer or broker about adding/removing members.
          <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>2.Submit Details:</span> Provide required information such as name, DOB, and occupation.
          <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>3.Underwriting Review:</span> Insurer reviews new members for eligibility and risk, adjusting premiums if needed.
          <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>4.Policy Amendment:</span> Insurer issues an updated policy with new coverage details, premiums, and effective dates.
          <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>5.Communicate Changes:</span> Inform affected members about the coverage adjustments.
          <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>6.Maintain Documentation:</span> Keep records of all policy amendments and related communications.
        </>
      )
       
    }
  ]);

const [visible, setVisible] = useState(false);
const [selectedFaqIndex, setSelectedFaqIndex] = useState(0);
const [isMobile, setIsMobile] = useState(false);

const toggleVisibility = () => {
  if (window.pageYOffset > 100) {
    setVisible(true);
  } else {
    setVisible(false);
  }
};

const scrollToTop = () => {
  setVisible(false); // Hide the button immediately when clicked
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

useEffect(() => {
  window.addEventListener('scroll', toggleVisibility);
  return () => {
    window.removeEventListener('scroll', toggleVisibility);
  };
}, []);

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  window.addEventListener('resize', handleResize);
  handleResize();

  return () => {
    window.removeEventListener('resize', handleResize);
  };
}, []);

const handleFaqClick = (index) => {
  setSelectedFaqIndex(selectedFaqIndex === index ? index : index);
};
return(
  <div>
     <div className='qa-section'>
        <img src={Wave} alt="Wave" className='waveimg' />
        <div className={`faq-ct ${isMobile ? 'mobile' : ''}`}>
          <div className="ct box">
            <div className="ct2">
              <h2 style={{ color: "#F37435", fontWeight: "700" }}>FAQ</h2>
              <p style={{ fontSize: "20px", fontWeight: "400", marginTop: '2rem' }}>Frequently Asked Questions</p>
            </div>
            <div className="subct">
              <ul style={{ listStyleType: "none", padding: 0 }}>
                {faqs.map((faq, index) => (
                  <li
                    className={`ct3 ${selectedFaqIndex === index ? "highlighted" : ""} ${isMobile ? "highlighted" : ""}`}
                    key={index}
                    onClick={() => handleFaqClick(index)}
                  >
                    <div className='faq-question'>
                      <strong className='view'>{faq.question}</strong>
                      <ArrowIcon className="arrow-icon" />
                    </div>
                    {isMobile && (
                      <span className={`arrow ${selectedFaqIndex === index ? "expanded" : ""}`}></span>
                    )}
                    {isMobile && selectedFaqIndex === index && (
                      <div className="subcon1 mobile-subcon">
                        <p>{faq.answer}</p>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {!isMobile && selectedFaqIndex !== null && (
            <div className="con">
              <div className="subcon">
                <p>{faqs[selectedFaqIndex].question}</p>
              </div>
              <div className="subcon1">
                <p>{faqs[selectedFaqIndex].answer}</p>
              </div>
            </div>
          )}
        </div>
        {visible && (
          <a
            href="#"
            id="scroll"
            onClick={scrollToTop}
            style={styles.scroll}
          >
            <img src={arrowBottom} alt="Scroll to top" style={{ height: '2rem' }} />
          </a>
        )}
      </div>
    </div>
  );
};

const styles = {
  scroll2: {
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    right: '10px',
    bottom: '10px',
    cursor: 'pointer',
    width: '50px',
    height: '50px',
    backgroundColor: 'white',
    borderRadius: '60px',
    zIndex: '1000',
    justifyContent: 'center',
  },
  span: {
    display: 'block'
  }
};
export default GroupPersonalAccidentFAQ;